import React from 'react';
import { createRoot } from 'react-dom/client';
import './styles/design-system.css'; // Design system CSS variables (must be first)
import './styles/custom.scss'; // Bootstrap SCSS + Classic Liturgical theme overrides
// Note: Do NOT import bootstrap.min.css - custom.scss already imports Bootstrap via SCSS
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root');
const root = createRoot(container!); // The '!' is a non-null assertion operator
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();